import { UseQueryOptions } from "@tanstack/react-query"

import { useMutationHook, useQueryHook } from "@/hooks"
import {
  readAssignableDevices,
  readDevices,
  readMatchedDevices,
  upsertMatchPlayerAndDevice,
} from "@/app/api/device"
import { Device, ReadDevicesResponse } from "@/types/device"
import { ApiError } from "@/app/api/type"

export const useDevicesQuery = () => {
  return useQueryHook<ReadDevicesResponse, unknown>({
    queryKey: ["readDevices"],
    queryFn: readDevices,
  })
}

export const useMatchedDeviceQuery = () => {
  return useQueryHook<Device[], unknown>({
    queryKey: ["readMatchedDevices"],
    queryFn: readMatchedDevices,
  })
}

export const useAssignableDevicesQuery = (idfPlayer?: number) => {
  return useQueryHook<Device[], unknown>({
    queryKey: ["readAssignableDevices", idfPlayer],
    queryFn: () => readAssignableDevices(idfPlayer),
    options: {
      enabled: !!idfPlayer,
    } as UseQueryOptions<Device[], ApiError>,
  })
}

export const useUpsertMatchPlayerAndDeviceMutation = () => {
  return useMutationHook(
    upsertMatchPlayerAndDevice,
    [
      ["readDevices"],
      ["readMatchedDevices"],
      ["readAssignableDevices"],
      ["readAssignablePlayers"],
      ["readPlayers"],
      ["readGroupPlayers"],
    ],
    {
      onError(error) {
        throw error
      },
    },
  )
}
